import React from 'react'
import styled from 'styled-components'
import Spinner from 'react-svg-spinner'

import Spacer from 'components/Spacer'
import Label from 'components/Label'

const Loader = ({ text }) => {
  return (
    <>
      <StyledLoader>
        <Spacer size="lg" />
        <Spinner />
        <Label size="12" text={text} />
      </StyledLoader>
    </>
  )
}

const StyledLoader = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
`
export default Loader
